import { createSlice } from '@reduxjs/toolkit'
import { getPageFilter, saveFilters } from "../../utils/index";

const initialState = {
  employeeLeaveCreditList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: getPageFilter('employeeLeaveCreditList'),
  },
  employeeLeaveCreditDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
}

export const employeeLeaveCreditSlice = createSlice({
  name: 'employeeLeaveCredit',
  initialState,
  reducers: {
    getEmployeeLeaveCreditList: (state, action) => {
      state.employeeLeaveCreditList.requesting = true
      state.employeeLeaveCreditList.error = null
      state.employeeLeaveCreditList.items = []
      state.employeeLeaveCreditList.success = false;
      saveFilters('employeeLeaveCreditList', action.payload);
    },
    getEmployeeLeaveCreditListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.employeeLeaveCreditList.requesting = false
      state.employeeLeaveCreditList.items = data
      state.employeeLeaveCreditList.success = true
      state.employeeLeaveCreditList.pagination.current_page = current_page
      state.employeeLeaveCreditList.pagination.per_page = per_page
      state.employeeLeaveCreditList.pagination.total = total
    },
    getEmployeeLeaveCreditListFail: (state, action) => {
      state.employeeLeaveCreditList.requesting = false
      state.employeeLeaveCreditList.error = action.payload
    },
    getEmployeeLeaveCreditDetails: (state) => {
      state.employeeLeaveCreditDetails.requesting = true
      state.employeeLeaveCreditDetails.error = null
      state.employeeLeaveCreditDetails.data = null
      state.employeeLeaveCreditDetails.success = false
    },
    getEmployeeLeaveCreditDetailsSuccess: (state, action) => {
      state.employeeLeaveCreditDetails.requesting = false
      state.employeeLeaveCreditDetails.data = action.payload
      state.employeeLeaveCreditDetails.success = true
    },
    getEmployeeLeaveCreditDetailsFail: (state, action) => {
      state.employeeLeaveCreditDetails.requesting = false
      state.employeeLeaveCreditDetails.error = action.payload
    },
    doEmployeeLeaveCreditCreate: (state) => {
      state.employeeLeaveCreditDetails.requesting = true
      state.employeeLeaveCreditDetails.error = null
      state.employeeLeaveCreditDetails.data = null
      state.employeeLeaveCreditDetails.success = false
    },
    doEmployeeLeaveCreditCreateSuccess: (state, action) => {
      state.employeeLeaveCreditDetails.requesting = false;
      state.employeeLeaveCreditDetails.data = action.payload;
      state.employeeLeaveCreditDetails.success = true;
    },
    doEmployeeLeaveCreditCreateFail: (state, action) => {
      state.employeeLeaveCreditDetails.requesting = false;
      state.employeeLeaveCreditDetails.error = action.payload;
      state.employeeLeaveCreditDetails.success = false;
    },
    doEmployeeLeaveCreditUpdate: (state) => {
      state.employeeLeaveCreditDetails.requesting = true
      state.employeeLeaveCreditDetails.error = null
      state.employeeLeaveCreditDetails.data = null
      state.employeeLeaveCreditDetails.success = false
    },
     doEmployeeLeaveCreditUpdateSuccess: (state, action) => {
      state.employeeLeaveCreditDetails.requesting = false;
      state.employeeLeaveCreditDetails.data = action.payload;
      state.employeeLeaveCreditDetails.success = true;
    },
    doEmployeeLeaveCreditUpdateFail: (state, action) => {
      state.employeeLeaveCreditDetails.requesting = false;
      state.employeeLeaveCreditDetails.error = action.payload;
      state.employeeLeaveCreditDetails.success = false;
    },
    doEmployeeLeaveCreditDelete: (state) => {
      state.employeeLeaveCreditDetails.requesting = true
      state.employeeLeaveCreditDetails.error = null
      state.employeeLeaveCreditDetails.data = null
      state.employeeLeaveCreditDetails.success = false
    },
    doEmployeeLeaveCreditReset: (state) => {
      state.employeeLeaveCreditDetails.data = null
    },
  },
})

export const {
  getEmployeeLeaveCreditList,
  getEmployeeLeaveCreditListSuccess, doEmployeeLeaveCreditCreateSuccess,
  getEmployeeLeaveCreditListFail, doEmployeeLeaveCreditCreateFail,
  getEmployeeLeaveCreditDetails, getEmployeeLeaveCreditDetailsSuccess,
  getEmployeeLeaveCreditDetailsFail, doEmployeeLeaveCreditCreate,
  doEmployeeLeaveCreditUpdateSuccess, doEmployeeLeaveCreditUpdateFail,
  doEmployeeLeaveCreditUpdate, doEmployeeLeaveCreditDelete,
  doEmployeeLeaveCreditReset,
} = employeeLeaveCreditSlice.actions

export default employeeLeaveCreditSlice.reducer
